import { useNavigate } from 'react-router-dom';
import { Camera } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';
import LadyScan from 'assets/lady-scan-right.png';
import { PATH_ROUTES } from 'routes/path';

export default function NoScanOverlay() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className='flex flex-1 items-center justify-center w-full min-h-60 bg-white border shadow-md rounded-xl'>
      <div className='flex flex-col items-center gap-y-4 px-4 py-8 sm:gap-12 sm:flex-row'>
        <div className='ml-4 size-24 sm:size-40 sm:ml-0'>
          <img
            src={LadyScan}
            alt='lady scan'
            className='object-contain h-full w-fit'
          />
        </div>

        <div className='flex flex-col items-center justify-center space-y-4'>
          <div className='max-w-xs'>
            <p className='font-semibold leading-tight text-center text-gray-900 sm:text-lg'>
              {t('do_first_face_scan')}
            </p>
          </div>

          <Button
            className='px-4 rounded-3xl bg-[#F68078] hover:bg-[#F68078]/90 text-sm sm:text-base'
            size='sm'
            onClick={() => navigate(PATH_ROUTES.FACE_SCAN)}
          >
            <Camera className='w-4 h-4 mb-px mr-2' />
            {t('start_scan')}
          </Button>
        </div>
      </div>
    </div>
  );
}
